import { Typography, Box, Container } from '@mui/material';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

      <ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="container subPageContainer">
          <Typography variant='h1' className='sectionTitle'>Impressum</Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>Angaben gemäß § 5 DDG</Typography>
          <Typography variant='body1' className='sectionText'>
            Notare Dr. Antonia Harbecke und Dr. Martin Konstantin Thelen<br />
            Am Brauhof 2<br />
            Siegburg 53721<br />
          </Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>Aufsichtsbehörde</Typography>
          <Typography variant='body1' className='sectionText'>
            Präsident des Landgerichts Bonn<br />
            Wilhelmstraße 21, 53111 Bonn <br /><br />
            Präsident des Oberlandesgerichts Köln<br />
            Reichenspergerplatz 1, 50670 Köln
          </Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>Berufsbezeichnung und besondere berufliche Regelungen</Typography>
          <Typography variant='body1' className='sectionText'>
            Berufsbezeichnung: Notar<br />
            Kammer: Rheinische Notarkammer<br /><br />

            Burgmauer 53, 50667 Köln<br />

            Verliehen in: Bundesrepublik Deutschland<br /><br />

            Der Berufsstand Notar / Notarin unterliegt den nachfolgenden Regelungen:<br /><br />

            - Bundesnotarordnung (BNotO)<br />
            - Beurkundungsgesetz (BeurkG)<br />
            - Verordnung über die Führung notarieller Akten und Verzeichnisse (NotAktVV)<br />
            - Gerichts- und Notarkostengesetz (GNotKG)<br />
            - Dienstordnung für Notarinnen und Notare (DONot)<br />
            - Richtlinien für die Amtspflichten und sonstigen Pflichten der Mitglieder der Rheinischen Notarkammer.<br /><br />

            Die bundesrechtlichen Regelungen können im Informationsportal der Bundesnotarkammer unter https://www.notar.de/der-notar/berufsrecht eingesehen werden. Die berufsrechtlichen Bestimmungen finden sich auf der Homepage der Bundesnotarkammer unter https://www.bnotk.de/aufgaben-und-taetigkeiten/richtlinien/richtlinien-der-notarkammern.
          </Typography>


          <Typography variant='h2' className='sectionTitle3 marginTop'>Verantwortliche</Typography>
          <Typography variant='body1' className='sectionText'>
            Notare Dr. Antonia Harbecke und Dr. Martin Konstantin Thelen <br />
            Am Brauhof 2 <br />
            53721 Siegburg
          </Typography>


        </Container>


        <Box className="section bannergrey" id="kontakt">
          <Container maxWidth="lg" className="container" id="kontakt">
            <Box className="kontaktGrid">
              <Box className="kontaktLeftSide smaller">
                <Typography variant='h2' className='sectionTitle white small'>
                  Sie haben Fragen?  <br />
                  Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                </Typography>
                <Typography variant='body1' paragraph className='whiteText smaller'>
                  <b>Öffnungszeiten</b><br />
                  Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                  Mittwoch ab 13:00 Uhr geschlossen<br />
                  Spätere Termine sind nach Vereinbarung möglich<br />
                </Typography>
                <Typography variant='body1' paragraph className='whiteText smaller'>
                  <b>Telefon</b><br />
                  Sie erreichen uns unter: 02241 66444<br />
                  Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                  Mittwoch nur bis 13:00 Uhr. <br />
                </Typography>
                <Typography variant='body1' paragraph className='whiteText smaller'>
                  <b>E-mail: info@ht-notare.de</b><br />
                </Typography>
                <Typography variant='body1' paragraph className='whiteText smaller'>
                  <b>Fax: 02241 55161</b><br />
                </Typography>
                <Typography variant='body1' paragraph className='whiteText smaller'>
                  <b>Anfahrt und Parkmöglichkeiten</b><br />
                  Das Büro befindet sich im Zentrum von Siegburg im Geschäftshaus Am Brauhof 2. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. Im Parkzentrum Holzgasse (Scheerengasse 5, 53721 Siegburg) können Sie die mit „HT Notare“ markierten Stellplätze 17a, 20, 27 und 29 kostenfrei nutzen. Diese erreichen Sie, indem Sie nach der Einfahrt in die Tiefgarage rechts abbiegen und dann in dieser Richtung bis zum Ende der Garage durchfahren. Hierbei passieren Sie eine rot leuchtende Ampel. Von den Stellplätzen aus gelangen Sie durch eine eigene Tür mit Klingelschild in das Treppenhaus und zum Lift. Weitere (kostenpflichtige) Parkmöglichkeiten befinden sich im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt liegend vom Büro.
                </Typography>
              </Box>
              <Contactform />
            </Box>
          </Container>
        </Box>

      </main >
      <Footer />
    </div >
  );
}

export default Imprint;